import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isBrowser as s, hasInstance as w } from "./utils.js";
import { on as u, off as c } from "../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { readonly as f, ref as i } from "../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { onBeforeMount as k, onBeforeUnmount as p } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const T = i(void 0);
let e = 0;
function a() {
  T.value = Date.now();
}
let d = !0;
function R(m) {
  if (!s)
    return f(i(!1));
  const n = i(!1);
  let o = null;
  function t() {
    o !== null && window.clearTimeout(o);
  }
  function r() {
    t(), n.value = !0, o = window.setTimeout(() => {
      n.value = !1;
    }, m);
  }
  e === 0 && u("click", window, a, !0);
  const l = () => {
    e += 1, u("click", window, r, !0);
  };
  return d && (d = w()) ? (k(l), p(() => {
    e -= 1, e === 0 && c("click", window, a, !0), c("click", window, r, !0), t();
  })) : l(), f(n);
}
export {
  R as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-clicked.js
// module id = 987
// module chunks = 67